<template>
  <div class="wrapper-lading pt-5">
    <div class="pt-5 row">
      <div class="col-md-1 col-lg-2"></div>
      <div class="col-3 col-sm-6 col-md-6 col-lg-3">
        <img
          style="float: right;margin-right: 70px;"
          src="@/assets/images/sangkien/cloud.5aae2b74.svg"
          alt
        />
      </div>
      <div class="col-4 col-sm-6 col-md-4 col-lg-4">
        <div class="pt-5">
          <img class="pt-5" src="@/assets/images/sangkien/fptlogo.png" alt />
        </div>
        <br />
        <div>
          <label class="title">Sáng Kiến</label>
        </div>
        <br />
        <div>
          <a :href="loginUrl" class="login">ĐĂNG NHẬP</a>
        </div>
      </div>
      <div class="col-3 col-lg-3"></div>
    </div>
    <div class="row">
        <img src="@/assets/images/sangkien/light.0c2cdd2d.svg" alt="">
    </div>
  </div>
</template>

<script>
import landingjs from "../../assets/js/landing/landing_center.js";
import * as CONFIG from "../../config/index";
import adfsCommon from '../../common/adfsCommon';
import azureCommon from '../../common/azureCommon';
import axios from 'axios'
export default {
  name: "LandingPage",
  data() {
    return {
      loginUrl: `${CONFIG.LOGIN_URL}`
    };
  },
  async mounted () {
    let urlQuery = new URLSearchParams(window.location.search);
    if (urlQuery && urlQuery.get('code')) {
      // let res = await adfsCommon.loginAdfs(urlQuery.get('code'));  //login with adfs     
      window.location.href = CONFIG.CLIENT_URL + "#/process-login/?code=" + urlQuery.get("code");
      // let res = await azureCommon.loginAzure(urlQuery.get('code'));   //login with azure    
      // this.$cookies.set("username", res.username, CONFIG.COOKIES_EXPIRED_TIME);
      // this.$cookies.set("accessToken", res.token, CONFIG.COOKIES_EXPIRED_TIME);
      // this.$cookies.set("roles", res.roles, CONFIG.COOKIES_EXPIRED_TIME);
      // this.$cookies.set("fsuBuAdmin", res.fsuBuAdmin, CONFIG.COOKIES_EXPIRED_TIME);
      // this.$cookies.set("accountCustomerAdmin", res.accountCustomerAdmin, CONFIG.COOKIES_EXPIRED_TIME);
      // this.$cookies.set("roleFsuBuDeptCode", res.roleFsuBuDeptCode, CONFIG.COOKIES_EXPIRED_TIME);
      // this.$cookies.set("userEmail", res.userEmail, CONFIG.COOKIES_EXPIRED_TIME);
      // this.$cookies.set("globalRoles", res.globalRoles, CONFIG.COOKIES_EXPIRED_TIME);
      // this.$cookies.set("company", res.company, CONFIG.COOKIES_EXPIRED_TIME);
      // window.localStorage.setItem('permissions', JSON.stringify(res.permissions));
      // axios.defaults.headers.common['Authorization'] = 'Bearer ' + res.token;
      // window.location.href = CONFIG.CLIENT_URL + "/#/home";
    }
  }
};
</script>

<style scoped>
.wrapper-lading {
  background: #2f363a 0 0 no-repeat padding-box;
  opacity: 1;
  overflow: hidden;
}
.title {
  text-align: left;
  font: 700 50px/68px Roboto;
  letter-spacing: 0;
  color: #fff;
  opacity: 1;
}
.login {
  background-color: #f46f21;
  border-radius: 5px;
  opacity: 1;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border-style: solid;
  border-color: #f46f21;
  color: #fff;
  padding: 5px;
  text-decoration:none;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/LandingPage.vue